import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

interface ILinkField {
  record: any;
  resource: string;
}

const useStyles = makeStyles({
  root: {
    textDecoration: "none",
    color: "#3f51b5",
  },
});

const LinkField = ({ record, resource }: ILinkField) => {
  const classes = useStyles();

  return (
    <Link
      to={`/${resource}/${record.id}/show`}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.root}
    >
      {`${record.firstName} ${record.lastName}`}
    </Link>
  );
};

export default LinkField;
